import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Hero from "./components/Hero";
import AttackGrid from "./components/AttackGrid";
import Footer from "./components/Footer";
import SQLiSimulator from "./components/SQLiSimulator"; // ✅ Import the target route
import NoSQLiSimulator from "./components/NoSQLiSimulator"; // ✅ Import the target route
import WiFiLab from "./components/WiFiLab";
import HashLab from "./components/HashLab";
import MITMLab from "./components/MITMLab";
import XSSLab from "./components/XSSLab";
import ProxyLab from "./components/ProxyLab";
import FirewallLab from "./components/FirewallLab";
import SocMonitoringLab from "./components/SocMonitoringLab";
import IDSLab from "./components/IDSLab";
import EncryptionLab from "./components/EncryptionLab";

import HashAudit from "./components/HashAudit";


function App() {

  
  return (
    <Router>
      <Routes>
        {/* Homepage */}
        <Route
          path="/"
          element={
            <>
              <div style={{ backgroundColor: "black", minHeight: "100vh" }}>
                <Hero />
                <div style={{ marginBottom: "3rem" }}>
                  <AttackGrid />
                </div>
                {/* <Footer /> */}
              </div>
            </>
          }
        />

        {/* SQL Injection Page */}
        <Route path="/sqlinjection" element={<SQLiSimulator />} />
        <Route path="/wifihacking" element={<WiFiLab />} />
        <Route path="/hashcracking" element={<HashLab />} />
        <Route path="/xssattack" element={<XSSLab />} />
        <Route path="/encrypt&decrypt" element={<EncryptionLab />} />
        <Route path="/proxyapi" element={<ProxyLab />} />
        <Route path="/mitm" element={<MITMLab />} />

        <Route path="/nosqlinjection" element={<NoSQLiSimulator />} />

        <Route path="/firewallacl" element={<FirewallLab />} />
        <Route path="/socmonitoring" element={<SocMonitoringLab />} />
        <Route path="/intrusiondetection" element={<IDSLab />} />



        <Route path="/passwordaudit" element={<HashAudit />} />


        {/* (Optional) placeholders for other pages to avoid blank routes */}
        <Route
          path="/xssattack"
          element={
            <h1 style={{ color: "white", textAlign: "center" }}>
              XSS Attack coming soon...
            </h1>
          }
        />
        <Route
          path="/phishing"
          element={
            <h1 style={{ color: "white", textAlign: "center" }}>
              Phishing coming soon...
            </h1>
          }
        />
        <Route
          path="/mitm"
          element={
            <h1 style={{ color: "white", textAlign: "center" }}>
              MITM coming soon...
            </h1>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
